import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/auth'

import HomePage from '../pages/HomePage.vue'
import ProfilePage from '../pages/ProfilePage.vue'
import PizzaPage from '../pages/PizzaPage.vue'
import CompetitionsIndexPage from '../pages/competitions/CompetitionsIndexPage.vue'
import CompetitionsNewPage from '../pages/competitions/CompetitionsNewPage.vue'
import CompetitionDetailPage from '../pages/competitions/CompetitionDetailPage.vue'
import SubmitVesselPage from '../pages/competitions/SubmitVesselPage.vue'

const routes: RouteRecordRaw[] = [
	{ path: '/', component: HomePage },
	{ path: '/profile', component: ProfilePage },
	{ path: '/pizza', component: PizzaPage },
	{ path: '/competitions', component: CompetitionsIndexPage },
	{ path: '/competitions/new', component: CompetitionsNewPage },
	{ path: '/competitions/:id', component: CompetitionDetailPage },
	{ path: '/competitions/:id/submit-vessel', component: SubmitVesselPage },
]

export const router = createRouter({
	history: createWebHistory(),
	routes,
})

router.beforeEach(async (to) => {
	const auth = useAuthStore()

	// Wait for initial auth check before navigating away from '/'
	if (auth.loading) {
		await auth.fetchMe()
	}

	const publicPaths = ['/pizza']
	if (!auth.user && !publicPaths.includes(to.path)) {
		// Not logged in — let the page component show the login prompt
		// (redirect to Discord happens server-side via /auth/discord)
		return true
	}

	return true
})
